<template>
  <h1>
    ***Link To Interactions Page in TORSH Talent*** </h2>
  </h1>
</template>
<script>
  import axios from 'axios';
  import MentorMenteeInteractionsModal from './components/MentorMenteeInteractionsModal.vue';
  export default {
    parent: true,

    props: {
      user: {
        type: Object,
        default: () => {},
      },
    },

    data: () => ({
      loadingInteractions: false,
      filter: '',
      interactions: [],

    }),

    method: {
      launchInteractionssModal() {
        this.$modal.open({
          parent: this,
          component: MentorMenteeInteractionsModal,
          hasModalCard: true,

        });
      },
      async getMentorMenteeInteractionsPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingAssignments = true;
        const { data } = await axios.get(`/api/assignments/paged?${params}`);
        this.assignments = data.resultItems;
        this.loadingAssignments = false;
      },
    },
  };
</script>